module.exports = __webpack_public_path__ + "static/media/ipad.946ba39b.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/record/img/ipad.png
// module id = 347
// module chunks = 0